module.exports = __webpack_public_path__ + "img/40_38_058_210.ae7fb97a.jpg";